import React from "react";
import axios from "axios";

function CheckRole (imba_id) {
    return new Promise((resolve, reject) => {
        axios.post(
            `https://api.imbachat.com/imbachat/v1/widget/user_by_token/${imba_id}`,
            {
                token: localStorage.getItem('comet-token')
            },
            {
                headers: {
                    //"Access-Control-Allow-Origin": "*",
                }
            }
        ).then((response) => {
            let data = response.data
                
               resolve(data.role);
        }).catch((error) => {
            reject(error)
    
        })
        
})


}

export default CheckRole;